export const controlPanelScenarioTypePulse = 'pulse';
export const controlPanelScenarioTypeToggle = 'toggle';

export const controlPanelScenarioType = [controlPanelScenarioTypeToggle, controlPanelScenarioTypePulse] as const;
export type ControlPanelScenarioType = typeof controlPanelScenarioType[number];
